import './Hero.css';
import background from '../assets/background.jpg';
import FeatureSection from './FeatureSection';
import Footer from './Footer';
// import ReportModal from './ReportModal'; 
import axios from 'axios';
import RiskMeter from './RiskMeter';
// import ShieldRow from './ShieldRow';
// import ScoreSummary from './ScoreSummary';
import React, { useState } from 'react';
// import PrepPanel from './PrepPanel';
import ReportModal from './ReportModal';
import { useAuth } from './AuthContext';

function Hero() {
  // State for form inputs and API response
  const { user } = useAuth();
  const [url, setUrl] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false); // NEW: Modal state
  const [prepLoading, setPrepLoading] = useState(false);
  const [prepData, setPrepData] = useState(null);
  const [prepErr, setPrepErr] = useState('');


  // Function to check URL safety with company verification and job description analysis 
  const handleGenerateReport = async () => {
  if (!url) { 
    setError('Please paste a job URL'); 
    return; 
  }
  
  setLoading(true);
  setError('');
  setResult(null);
  setPrepData(null);
  
  try {
    // Call /api/analyze (doesn't require auth)
    const res = await axios.post('/api/analyze', { 
      url: url,
      userId: user ? user.id : null // <--- This is the key change!
    });
    
    // res.data = { summary, checks, meta }
    // Convert this to look like result for the modal
    const analysisResult = {
      checks: res.data.checks,
      summary: res.data.summary,
      meta: res.data.meta,
      safe: res.data.summary?.risk === 'low',
      riskLevel: res.data.summary?.risk || 'unknown'
    };
    
    setResult(analysisResult);
    setPrepData(res.data);
    
  } catch (e) {
    setError(e?.response?.data?.message || e.message || 'Request failed');
    setResult(null);
  } finally {
    setLoading(false);
  }
};


  return (
    <div
      className="background-container"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="overlay">
        <div className="hero-content">
          <h1 className="headline">
            <span className="gradient-text">JobFAX Report Generator.</span><br />
            Verify before you apply.
          </h1>

          <div className="input-section">
            <div className="input-row">
              <input 
                className="url-input" 
                type="text" 
                placeholder="Paste job URL here (shortened URLs will be expanded)"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                disabled={loading}
              />
              <button 
                className="report-button"
                onClick={handleGenerateReport}
                disabled={loading}
              >
                {prepLoading ? 'Analyzing…' : 'Run PREP'}
              </button>
            </div>


            {prepErr && <div className="error-message">❌ {prepErr}</div>}

            {prepData && (
              <div style={{ marginTop: 16 }}>
                {/* Keep your gauge */}
                <div style={{ display: 'grid', placeItems: 'center', marginBottom: 12 }}>
                  <RiskMeter score={prepData.summary?.score ?? 0} />
                </div>

                {/* NEW: the PREP panel */}
                {/* <PrepPanel data={prepData} /> */}
                

                {/* {prepData.meta?.finalUrl && (
                  <p style={{ marginTop: 10, fontSize: 12, color: '#9ca3af' }}>
                    Final URL: <code>{prepData.meta.finalUrl}</code>
                  </p>
                )} */}
              </div>
            )}




            {/* <div className="company-input-row">
              <input 
                className="company-input" 
                type="text" 
                placeholder="Company name (e.g., Microsoft, Google) - Optional but recommended"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                disabled={loading}
              />
            </div>
            
            <textarea 
              className="description-box" 
              placeholder="Optional: Paste job description for additional context..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              disabled={loading}
            /> */}

            {/* Error Display */}
            {error && (
              <div className="error-message">
                ❌ {error}
              </div>
            )}
            
            {/* NEW: Simple Results Summary + View Report Button */}
            {result && !result.error && (
              <div className="results-summary">
                <div className={`summary-card ${result.riskLevel}`}>
                  <div className="summary-header">
                    <div className="summary-status">
                      {result.safe ? (
                        <span className="status-safe">✅ Job posting appears legitimate</span>
                      ) : (
                        <span className="status-unsafe">⚠️ Potential fraud detected</span>
                      )}
                    </div>
                    
                  </div>
                  
                  <div className="summary-details">
                    <p>
                      Analysis complete! We've checked the URL safety, company verification, 
                      job description quality, and hiring patterns.
                    </p>
                  </div>

                  <div className="summary-actions">
                    <button 
                      className="view-report-button"
                      onClick={() => setShowModal(true)}
                    >
                      🛡️ View Detailed Report
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* API Error Display */}
            {result && result.error && (
              <div className="error-message">
                ❌ Analysis failed: {result.error}
              </div>
            )}
          </div>
        </div>
        
        <FeatureSection />
        <Footer />
      </div>
      {/* Report Modal */}
      {showModal && result && (
        <ReportModal result={result} onClose={() => setShowModal(false)} />
      )}
    </div>
  );
}

export default Hero;





